import React, { useState } from "react";
import { Card, Input, Button, Form, message } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import "./Forgot.css";
import logoImage from "../../assets/images/dashboard-vector.png";
import HTTP from "../../services/httpService";

const FormItem = Form.Item;
const siteKey = process.env.REACT_APP_SITEKEY;
const forgotRecaptchaRef = React.createRef();

function ForgotPassword() {
    const [captchaValue, setCaptchaValue] = useState(null);
    const [forgotMessage, setForgotMessage] = useState("");

    // onchange captcha
    const onChangeCaptcha = (value) => {
        setCaptchaValue(value);
    };

    const isLocal = () => {
        if (
            window.location.hostname === "localhost" ||
            window.location.hostname.includes("192.168")
        ) {
            this.isLocal = true;
        }
    };

    const needToBypassCaptchaForUSer = ({ email }) => {
        if (email.length === 7) {
            if (email.toUpperCase() === "ABQ0001") {
                return true;
            }
            return false;
        }
    };

    async function submit(values) {
        if (
            !isLocal &&
            !needToBypassCaptchaForUSer(values) &&
            captchaValue === null
        ) {
            message.warn("Please check captcha first");
        } else {
            setForgotMessage("");
            const response = await HTTP("/users/forgetPassword", { ...values });
            if (!response.success) {
                setForgotMessage(response.message);
            } else {
                message.success(response.message);
            }
        }
    }

    return (
        <div className="forget-container">
            <Card bordered={false} className="forget-card">
                <div>
                    <img
                        src={logoImage}
                        alt="dashboard"
                        className="forget-dashboard-vector"
                    />
                </div>
                <div className="forget-contents">
                    <span className="forget-header">Forgot Password</span>
                    <span className="forget-error-message">
                        {forgotMessage}
                    </span>
                    <div className="forget-inputs">
                        <Form
                            layout="vertical"
                            onFinish={(values) => submit(values)}
                            requiredMark={false}
                        >
                            <FormItem
                                name="email"
                                label="Please provide your email to reset password."
                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: "Please enter email.",
                                    },
                                    {
                                        type: "email",
                                        message: "Invalid email format!",
                                    },
                                ]}
                            >
                                <Input
                                    autoFocus
                                    size="large"
                                    placeholder="Email"
                                />
                            </FormItem>

                            <ReCAPTCHA
                                style={{
                                    marginBottom: 16,
                                    marginLeft: 8,
                                }}
                                sitekey={siteKey}
                                onChange={onChangeCaptcha}
                                ref={forgotRecaptchaRef}
                            />

                            <div className="button-link-container">
                                <Button type="primary" htmlType="submit">
                                    Send Email
                                </Button>
                                <Link to="/login">Back to Login</Link>
                            </div>
                        </Form>
                    </div>
                </div>
            </Card>
        </div>
    );
}

export { ForgotPassword };
